import { ModelType } from '~/app/base/schemas/BaseSchema';
import EndpointFactory from '~/app/factories/EndpointFactory';

export interface DocumentQuota {
    key: string;
    usage: number;
    limit: number;
}

export type QuotaType = 'documents' | 'expenses';

export const useDocumentQuotaStore = defineStore('DocumentQuotaStore', () => {
    const quotas = ref<Record<QuotaType, DocumentQuota | null>>({
        documents: null,
        expenses: null,
    });

    const loadDocuments = async () => {
        const endpoint = EndpointFactory.make(ModelType.INVOICES);
        const response = await endpoint.index({
            page: { number: 1, size: 1 },
            filter: { documentType: 'invoice' },
        });

        if (!response.error && response.data) {
            quotas.value.documents = response.data.meta?.quota ?? null;
        }
    };

    const loadExpenses = async () => {
        const endpoint = EndpointFactory.make(ModelType.EXPENSES);
        const response = await endpoint.index({
            page: { number: 1, size: 1 },
        });

        if (!response.error && response.data) {
            quotas.value.expenses = response.data.meta?.quota ?? null;
        }
    };

    const load = () => Promise.all([loadDocuments(), loadExpenses()]);

    const refresh = (type?: QuotaType) => {
        if (type === 'documents') return loadDocuments();
        if (type === 'expenses') return loadExpenses();
        return load();
    };

    const getQuota = (type: QuotaType) => quotas.value[type];

    return { quotas, load, refresh, getQuota };
});
